import { Badge } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import type { StatusGravacao } from '../types/Painel';

const TONE = {
  sucesso: 'success',
  pendente: 'warning',
  falha: 'danger',
  cancelada: 'neutral',
} as const;

export function GravacaoBadge({ status }: { status: StatusGravacao }) {
  const { t } = useTranslation('participantes');
  return <Badge tone={TONE[status]}>{t(`painel.gravacao.${status}`)}</Badge>;
}
